import axios from 'axios'
import {
  message as antMessage
} from 'ant-design-vue'
import cookieUtil from './cookie-util'

import router from '../router/index'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 0
})
axiosInstance.interceptors.request.use(config => {
  // config.headers.Authorization = cookieUtil.getToken()
  config.headers.Authorization = localStorage.getItem("admin_token")
  return config
}, error => {
  console.log(error)
})

const pipe = res => {
  return new Promise((resolve, reject) => res
    .then(data => {
      const {
        status,
        message
      } = data.data
      if (status === 200) resolve(data.data)
      else if (status === 400) {
        // cookieUtil.removeToken()
        localStorage.removeItem("admin_token")
        antMessage.error(message)
        router.push({
          path: '/'
        })
      } else {
        antMessage.error(message || '请求失败')
        reject(data.data)
      }
    }).catch(e => {
      let errorMessage = '请求失败'
      if (e.toString().includes('timeout of')) {
        errorMessage = '请求超时'
      } else if (e.toString().includes('Network Error')) {
        errorMessage = '服务器未响应,请检查网络'
      }
      antMessage.error(errorMessage)
      reject(e)
    })
  )
}

const post = (url, data) => {
  return pipe(axiosInstance({
    url: url,
    method: 'post',
    data: data
  }))
}

const get = (url, params) => {
  return pipe(axiosInstance({
    url: url,
    method: 'get',
    params: params
  }))
}

const deletes = (url, params) => {
  return pipe(axiosInstance({
    url: url,
    method: 'delete',
    params: params
  }))
}

const downFile = (url, args = {}, method = 'get') => {
  const requestParams = {
    url: url,
    method: method,
    responseType: 'blob'
  }
  const paramsKey = method === 'get' ? 'params' : 'data'
  requestParams[paramsKey] = args.params
  axiosInstance(requestParams).then(res => {
    blobDownloads(res, args.fileName)
  })
}

export {
  axiosInstance,
  axios,
  post,
  get,
  deletes,
  downFile
}
